import React from 'react';
import { View } from 'react-native';

import { VFText, Icon, Label } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { getThemeColors as getLoginThemeColors, getThemeImages } from '../../../Themes';
import LoginTestKeys from '../../../Utils/LoginTestKeys';
import CountDown from '../CountDown';
import VFCodeInput from '../VFCodeInput';

import styles from './VerifyForm.Styles';

function VerifyForm({
  isVerifying,
  error,
  codeLength,
  codeInputTextStyle,
  resendCodeDisabled,
  withCountdown,
  countdownProps,
  resendCodeTimeout,
  phone,
  theme,
  onBackPress,
  resendSms,
  codeVerify,
  handlerOnFulfill,
  onFocus,
  keyboardType,
}) {
  const images = getThemeImages(theme.name);
  const loginColors = getLoginThemeColors(theme.name);

  return (
    <View style={styles.container}>
      <View style={styles.infoContainer}>
        <VFText
          style={styles.infoText}
          i18nKey="verification_sent_code_text"
          accessibilityLabel={LoginTestKeys.verificationInfoTxt}
          testID={LoginTestKeys.verificationInfoTxt}
        />
        <View style={styles.infoChangeNumberContainer}>
          <VFText
            style={styles.infoPhone}
            i18nKey={phone}
            accessibilityLabel={LoginTestKeys.verificationInfoPhone}
          />
          <VFText
            style={styles.infoChangeNumber(theme)}
            i18nKey="verification_change_number_text"
            accessibilityLabel={LoginTestKeys.changeNumberLink}
            onPress={onBackPress}
          />
        </View>
        <VFText
          style={styles.infoText}
          i18nKey="verification_enter_code_text"
          testKey={LoginTestKeys.verificationCodeTxt}
        />
      </View>
      <VFCodeInput
        ref={codeVerify}
        colors={loginColors}
        codeLength={codeLength}
        codeInputTextStyle={codeInputTextStyle}
        onFulfill={handlerOnFulfill}
        onFocus={onFocus}
        isError={error}
        autoFocus={!error}
        keyboardType={keyboardType}
      />
      {!isVerifying ? (
        <View style={withCountdown ? styles.resendWithCounterContainer : styles.resendLabelWrapper}>
          <Label
            title="verification_resend_login_code_text"
            style={styles.label}
            textStyle={styles.textLabel(resendCodeDisabled)}
            onPress={resendSms}
            textAccessibilityLabel={LoginTestKeys.loginResendCodeLink}
            secondLabelTestId={LoginTestKeys.loginResendCodeLink}
            disabled={resendCodeDisabled}
          />

          <CountDown
            withCountdown={withCountdown}
            resendCodeDisabled={resendCodeDisabled}
            countdownProps={countdownProps}
            resendCodeTimeout={resendCodeTimeout}
          />
        </View>
      ) : (
        <View style={styles.loadingContainer}>
          <Icon
            style={styles.icon}
            name={images.ic_sync}
            type="image"
            size={25}
            accessibilityLabel={LoginTestKeys.loginVerifyIcon}
          />
          <VFText
            style={styles.loadingText(loginColors)}
            i18nKey="verification_verifying_login_code_text"
            accessibilityLabel={LoginTestKeys.loginVerifyTxt}
          />
        </View>
      )}
    </View>
  );
}

VerifyForm.defaultProps = {
  theme: LightThemeColors,
};

VerifyForm.propTypes = {
  isVerifying: PropTypes.bool,
  error: PropTypes.bool,
  codeLength: PropTypes.number,
  codeInputTextStyle: TextPropTypes.style,
  resendCodeDisabled: PropTypes.bool,
  withCountdown: PropTypes.bool,
  countdownProps: PropTypes.object,
  resendCodeTimeout: PropTypes.number,
  phone: PropTypes.string,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  onBackPress: PropTypes.func,
  resendSms: PropTypes.func,
  codeVerify: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  handlerOnFulfill: PropTypes.func,
  onFocus: PropTypes.func,
  keyboardType: PropTypes.string,
};

export default withTheme(VerifyForm);
